import React, { useState, forwardRef, useImperativeHandle } from 'react';

import { InputAdornment } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Visibility from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import { TextInput, AutoCompleteRemoto } from '../../../Components';
import { api, getUserId } from '../../../services';
import { STATUS_ATIVO } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, handleAutorizado }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const [user, setUser] = useState(null);
    const [senha, setSenha] = useState('');
    const [gerenteUser, setGerenteUser] = useState(null);
    const [senhaGerenteUser, setSenhaGerenteUser] = useState('');
    const [testemunhaUser, setTestemunhaUser] = useState(null);
    const [senhaTestemunhaUser, setSenhaTestemunhaUser] = useState('');
    // 1 = responsável pelo recebimento, 2 = gerente, 3 = testemunha
    const [etapa, setEtapa] = useState(1);

    const classes = useStyles({ cor: '#009FD4' });

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    async function getUser() {
      const response = await api.get(`/users/${getUserId()}`);
      return response.data;
    }

    async function reiniciar() {
      setEtapa(1);
      setUser(null);
      setSenha('');
      setGerenteUser(await getUser());
      setSenhaGerenteUser('');
      setTestemunhaUser(null);
      setSenhaTestemunhaUser('');
    }

    useImperativeHandle(ref, () => ({
      handleOpen() {
        reiniciar();
        setOpen(true);
      },
    }));

    function validateUser() {
      let error = '';
      if (!user) {
        error = 'Este campo é obrigatório';
      } else if (gerenteUser) {
        if (user.id === gerenteUser.id) {
          error =
            'O operador de caixa não pode ser também o gerente neste registro!';
        } else if (testemunhaUser) {
          if (user.id === testemunhaUser.id) {
            error =
              'O operador de caixa não pode ser também a testemunha neste registro!';
          }
        }
      }
      return error;
    }

    function validateGerenteUser() {
      let error = '';
      if (!gerenteUser) {
        error = 'Este campo é obrigatório';
      }
      return error;
    }

    function validateTestemunhaUser() {
      let error = '';
      if (!testemunhaUser) {
        error = 'Este campo é obrigatório';
      } else if (gerenteUser) {
        if (testemunhaUser.id === gerenteUser.id) {
          error = 'A testemunha não pode ser também o gerente neste registro!';
        }
      }
      return error;
    }

    function validateSenhaUser() {
      let error = '';
      if (!senha) {
        error = 'Este campo é obrigatório';
      }
      return error;
    }

    function validateSenhaGerenteUser() {
      let error = '';
      if (!senhaGerenteUser) {
        error = 'Este campo é obrigatório';
      }
      return error;
    }

    function validateSenhaTestemunhaUser() {
      let error = '';
      if (!senhaTestemunhaUser) {
        error = 'Este campo é obrigatório';
      }
      return error;
    }

    function getErros() {
      const errosOld = [''];
      errosOld[0] = validateUser();
      errosOld[1] = validateGerenteUser();
      errosOld[2] = validateTestemunhaUser();
      errosOld[3] = validateSenhaUser();
      errosOld[4] = validateSenhaGerenteUser();
      errosOld[5] = validateSenhaTestemunhaUser();
      return errosOld;
    }

    const erros = getErros();

    function hasError() {
      for (let i = 0; i < erros.length; i += 1) {
        if (erros[i] !== '') return true;
      }
      return false;
    }

    const erroExistente = hasError();

    // erros da etapa atual (cada etapa pede um usuário e a senha dele); na última, qualquer erro
    // impede autorizar (ex.: operador e testemunha iguais é um erro do campo da etapa 1)
    const primeiroErro = erros.find((erro) => erro !== '') || '';
    const erroDaEtapa =
      etapa === 1
        ? erros[0] || erros[3]
        : etapa === 2
        ? erros[1] || erros[4]
        : primeiroErro;

    function voltar() {
      if (etapa > 1) setEtapa(etapa - 1);
      else handleCloseDialog();
    }

    async function handleSalvarDialog() {
      if (!erroExistente) {
        try {
          let response = await api.post('/login_retirada_caixa', {
            username: user.username,
            password: senha,
          });

          if (!response.data.status)
            throw `Operador de Caixa, ${response.data.message}`;

          response = await api.post('/login_retirada_caixa', {
            username: gerenteUser.username,
            password: senhaGerenteUser,
          });

          if (!response.data.status) throw `Gerente, ${response.data.message}`;

          response = await api.post('/login_retirada_caixa', {
            username: testemunhaUser.username,
            password: senhaTestemunhaUser,
          });

          if (!response.data.status)
            throw `Testemunha, ${response.data.message}`;

          handleAutorizado({
            user,
            gerente: gerenteUser,
            testemunha: testemunhaUser,
          });

          setOpen(false);

          handleCloseDialog();
        } catch (e) {
          enqueueSnackbar(
            typeof e === 'string'
              ? e
              : 'Erro ao validar as senhas. Tente novamente.',
            {
              variant: 'error',
            },
          );
        }
      }
    }

    function avancar() {
      if (erroDaEtapa) return;
      if (etapa < 3) setEtapa(etapa + 1);
      else handleSalvarDialog();
    }

    const titulos = {
      1: 'Responsável pelo Recebimento (1/3)',
      2: 'Gerente (2/3)',
      3: 'Testemunha (3/3)',
    };

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            {`Autorização do Isento - ${titulos[etapa]}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                marginTop: '10px',
              }}
            >
              <fieldset
                style={{
                  width: '100%',
                  display: etapa === 1 ? 'flex' : 'none',
                  padding: '10px',
                  borderRadius: '5px',
                }}
              >
                <legend style={{ padding: '0 10px' }}>
                  Responsável pelo Recebimento de Mercadorias
                </legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={user}
                      onChange={(value) => setUser(value)}
                      error={erros[0] !== ''}
                      helperText={erros[0]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{ status: STATUS_ATIVO }}
                      resource="users"
                      campo="username"
                      autoFocus
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={avancar}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senha}
                      onChange={(event) => {
                        setSenha(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[3] !== ''}
                      helperText={erros[3]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              <fieldset
                style={{
                  width: '100%',
                  display: etapa === 2 ? 'flex' : 'none',
                  //margin: '20px',
                  padding: '10px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <legend style={{ padding: '0 10px' }}>Gerente</legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={gerenteUser}
                      onChange={(value) => setGerenteUser(value)}
                      error={erros[1] !== ''}
                      helperText={erros[1]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{
                        status: STATUS_ATIVO /* , is_responsavel: true */,
                      }}
                      resource="users"
                      campo="username"
                      disabled
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={avancar}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senhaGerenteUser}
                      onChange={(event) => {
                        setSenhaGerenteUser(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[4] !== ''}
                      helperText={erros[4]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              <fieldset
                style={{
                  width: '100%',
                  display: etapa === 3 ? 'flex' : 'none',
                  //margin: '20px',
                  padding: '10px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <legend style={{ padding: '0 10px' }}>Testemunha</legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={testemunhaUser}
                      onChange={(value) => setTestemunhaUser(value)}
                      error={erros[2] !== ''}
                      helperText={erros[2]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{ status: STATUS_ATIVO }}
                      resource="users"
                      campo="username"
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={avancar}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senhaTestemunhaUser}
                      onChange={(event) => {
                        setSenhaTestemunhaUser(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[5] !== ''}
                      helperText={erros[5]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              {etapa === 3 && erroDaEtapa && (
                <Box color="red" fontWeight="bold">
                  {erroDaEtapa}
                </Box>
              )}
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: '0px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={voltar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              {etapa > 1 ? 'Voltar' : 'Fechar'}
            </Button>
            <div className={classes.wrapper}>
              <Button
                onClick={avancar}
                classes={{
                  root: classes.btnAtions,
                  disabled: classes.btnAtionsDisabled,
                }}
                disabled={!!erroDaEtapa}
                variant="contained"
                color="primary"
              >
                {etapa < 3 ? 'Avançar' : 'Autorizar'}
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
